import React from "react";
import "./footer.css";
const Footer = () => {
  return <footer>Last updated on 18 May 2022 by Aakash Upadhyay</footer>;
};

export default Footer;